
import React from 'react';
import { ViewMode } from '../types';

interface FooterProps {
  onNavigate: (view: ViewMode) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const scrollToServices = (e: React.MouseEvent) => {
    e.preventDefault();
    onNavigate(ViewMode.LANDING);
    setTimeout(() => {
      const el = document.getElementById('services');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="bg-white border-t border-slate-100 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div className="col-span-1 md:col-span-1">
            <div className="flex items-center mb-6">
              <div className="flex mr-2">
                <div className="w-4 h-6 bg-[#2E4A96] rounded-sm"></div>
                <div className="w-4 h-6 bg-[#1CB496] rounded-sm ml-0.5"></div>
              </div>
              <div className="flex items-baseline">
                <span className="text-[#2E4A96] font-black text-xl">Whitefield</span>
                <span className="text-[#1CB496] font-black text-xl ml-0.5">Health</span>
              </div>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed mb-8 font-medium">
              Elite healthcare for Bangalore's most discerning families. We combine cutting-edge monitoring with traditional empathy to deliver the "Peace of Mind" your family deserves.
            </p>
          </div>

          <div>
            <h4 className="text-[#2E4A96] font-black text-xs uppercase tracking-[0.2em] mb-8">Our Services</h4>
            <ul className="space-y-4 text-sm text-slate-500 font-bold">
              <li><button onClick={scrollToServices} className="hover:text-[#1CB496] transition-colors">Elderly Companionship</button></li>
              <li><button onClick={scrollToServices} className="hover:text-[#1CB496] transition-colors">24/7 Nursing Care</button></li>
              <li><button onClick={scrollToServices} className="hover:text-[#1CB496] transition-colors">ICU Step-Down</button></li>
              <li><button onClick={scrollToServices} className="hover:text-[#1CB496] transition-colors">Diabetes Management</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#2E4A96] font-black text-xs uppercase tracking-[0.2em] mb-8">Quick Links</h4>
            <ul className="space-y-4 text-sm text-slate-500 font-bold">
              <li><button onClick={() => onNavigate(ViewMode.SAFETY)} className="hover:text-[#1CB496] transition-colors">Safety Protocols</button></li>
              <li><button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="hover:text-[#1CB496] transition-colors">Service Areas</button></li>
              <li><button onClick={() => onNavigate(ViewMode.BOOKING)} className="hover:text-[#1CB496] transition-colors">Book Concierge</button></li>
              <li><button onClick={() => onNavigate(ViewMode.BOOKING)} className="hover:text-[#1CB496] transition-colors">Corporate Care</button></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#2E4A96] font-black text-xs uppercase tracking-[0.2em] mb-8">Whitefield HQ</h4>
            <p className="text-sm text-slate-500 mb-6 leading-relaxed font-medium">
              No 148, 3rd cross,<br />
              Vijayanagar, Whitefield,<br />
              Bangalore 560066
            </p>
            <div className="p-5 bg-slate-50 rounded-2xl border border-slate-100">
               <p className="text-xs text-slate-400 font-bold uppercase mb-1">Emergency Help</p>
               <div className="text-xl text-[#2E4A96] font-black">9986928692</div>
            </div>
          </div>
        </div>

        <div className="pt-10 border-t border-slate-50 flex flex-col md:flex-row justify-between items-center text-[10px] text-slate-400 font-bold uppercase tracking-widest gap-4">
          <p>© 2025 Whitefield Health Pvt Ltd. All Rights Reserved.</p>
          <div className="flex space-x-8">
            <button onClick={() => onNavigate(ViewMode.SAFETY)} className="hover:text-[#1CB496]">Safety Policy</button>
            <button className="hover:text-[#1CB496]">Privacy</button>
            <button className="hover:text-[#1CB496]">Complaints</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
